<template>
  <div>
    <Top></Top>
    <div class="main">
      <h2>{{title}}</h2>
      <h6>{{datetime}}</h6>
      <p>{{`${Message}`}}</p>
    </div>
    <Foot></Foot>
  </div>
</template>
<script>
import Top from "../../components/head/Top";
import Foot from "../../components/foot/Foot";

export default {
  data() {
    return {
      title: this.$route.query.title,
      datetime: this.$route.query.datetime,
      Message: this.$route.query.Message
    };
  },
  components: {
    Top,
    Foot
  },
  methods: {}
};
</script>
<style lang='scss' scoped>
.main {
  width: 1200px;
  margin: 50px auto;
  h2 {
    font-size: 35px;
    text-align: center;
    color: #F3C622;
  }
  h6 {
    margin: 50px 0;
    text-align: right;
    font-size: 20px;
  }
  p {
    width: 800px;
    margin: 0 auto 50px;
    line-height: 40px;
    font-size: 20px;
    text-indent: 2em;
  }
}
</style>